<button
  class="button"
  [disabled]="disabled || loading"
  [attr.type]="type"
  [attr.form]="form"
  [class.button--full-width]="fullWidth"
  [class.button--small]="size === 'small'"
  [class.button--large]="size === 'large'"
  [class.button--outline]="buttonOutline"
  [class.button--filled]="buttonFilled"
  [class.button--tonal]="buttonTonal"
  [class.button--rounded]="buttonRounded"
  [class.button--link]="buttonLink"
  [class.button--loading]="loading"
>
  <tpm-icon class="button-icon" *ngIf="icon" [icon]="icon"></tpm-icon>
  <span class="button-content">
    <ng-content></ng-content>
  </span>
  <tpm-icon class="button-icon" *ngIf="iconRight" [icon]="iconRight"></tpm-icon>
  <tpm-spinner *ngIf="loading"></tpm-spinner>
</button>
